import { computed, ref, watch } from 'vue';
import useWishListCheckQuery from '../../../composables/useWishListCheckQuery';
import useProductListQuery from './useProductListQuery';

export default function useProductList(paginator, filters, sorts, productList = null) {
  const {
    data,
    isFetching,
    isFetchingNextPage,
    isFetchingPreviousPage,
    fetchNextPage,
    fetchPreviousPage,
    hasPreviousPage,
    hasNextPage,
  } = useProductListQuery(paginator, filters, sorts, productList);

  const wishes = ref([]);

  const productIds = computed(() => data.value?.pages
    ?.flatMap((page) => page.data.paginator.data.map((product) => product.id)));

  const { data: dataWishes, isFetching: isFetchingWishes } = useWishListCheckQuery(productIds);

  watch(dataWishes, (value) => {
    if (value?.data?.products) {
      wishes.value = value.data.products;
    }
  });

  return {
    data,
    wishes,
    isFetching: isFetching || isFetchingWishes,
    isFetchingNextPage,
    isFetchingPreviousPage,
    fetchNextPage,
    fetchPreviousPage,
    hasPreviousPage,
    hasNextPage,
  };
}
